<template>
    <div id="power">
        <div class="search-box">
            <p>权限名：</p>
            <a-input allow-clear v-model="powerName"/>
            <p>权限标识：</p>
            <a-input allow-clear v-model="permission"/>
            <a-button type="primary" icon="search" class="search-btn" @click="searchTable">搜索</a-button>
            <a-button type="primary" icon="plus" class="add-btn" @click="okText='新增';showAdd=true" v-if="permissions.includes('back:permission:add')">新增</a-button>
        </div>
        <a-table
            rowKey="id"
            :columns="columns"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            bordered
        >
            <span slot="idNum">{{pagination.pageSize}}</span>
            <span slot="id" slot-scope="text, record">
                <a v-if="permissions.includes('back:permission:update')" @click="editPower(record)">编辑</a>
                <a-divider type="vertical"/>
                <a v-if="permissions.includes('back:permission:delete')" @click="delPower(record)">删除</a>
            </span>
            <template slot="name" slot-scope="name"> {{ name.first }} {{ name.last }} </template>
        </a-table>
        <a-modal v-model="showAdd" :title="okText+'权限'" @ok="addPower" @cancel='cancelAdd' cancelText="取消" :okText='okText'>
            <div class="input-box">
                <p>权限名：</p>
                <a-input allow-clear v-model="addName" maxLength='50'/>
            </div>
            <div class="input-box">
                <p>权限标识：</p>
                <a-input allow-clear v-model="addPermission" maxLength='50' :disabled="okText!='新增'?true:false"/>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const columns = [
  {
    title: '序号',
    dataIndex: 'idNum',
  },
  {
    title: '权限名',
    dataIndex: 'name',
  },
  {
    title: '权限标识',
    dataIndex: 'permission',
  },
  {
    title: '修改时间',
    dataIndex: 'createTime',
  },
  {
    title: '操作',
    dataIndex: 'id',
    width: 150,
    scopedSlots: { customRender: 'id' },
  },
];
export default {
  name: 'Power',
  components: {
  },
  computed: {
    ...mapState({
      permissions: state => state.user.permissions
    })
  },
  data() {
    return {
        data: [],
        pagination: {
            pageSize:0
        },
        loading: false,
        columns,
        powerName:'',
        permission:'',
        tableSize:'10',
        showAdd: false,
        addName:'',
        addPermission:'',
        okText:'',
        putId:'',
    }
  },
  mounted () {
    this.fetch({
        size: this.tableSize,
        current: 1,
        name:this.powerName,
        permission:this.permission,
    });
  },
  methods:{
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetch({
        size: pagination.pageSize,
        current: pagination.current,
        name:this.powerName,
        permission:this.permission,
      });
    },
    fetch(params = {}) {
        this.pagination = params;
        this.loading = true;
        this.baseAPI.axiosData('/api-u/permissions?size='+params.size+'&current='+params.current+'&name='+params.name+'&permission='+params.permission,'get',{}).then(res => {
            const pagination = { ...this.pagination };
            params.size+=''
            pagination.pageSize = params.size-0;
            pagination.total = res.data.total;
            for(let i=0;i<res.data.records.length;i++)
            {
                res.data.records[i].idNum=(params.size*(params.current-1))+i+1;
            }
            this.loading = false;
            this.data = res.data.records;
            this.pagination = pagination;
        })
    },
    searchTable()
    {
        this.fetch({ 
            size: this.tableSize,
            current: 1,
            name:this.powerName,
            permission:this.permission,
        });
    },
    addPower()
    {
        if(this.okText=='新增')
        {
            let dataObj={
                permission:this.addPermission,
                name:this.addName
            }
            this.baseAPI.axiosData('/api-u/permissions','post',dataObj).then(res => {
                if(res.data.success)
                {
                    this.$notification['success']({
                        message: '添加成功',
                    });
                    this.addPermission='';
                    this.addName='';
                    this.showAdd = false;
                }
                else
                {
                    this.$notification['error']({
                        message: res.data.errorMessage,
                    });
                }
            })
        }
        else if(this.okText=='修改')
        {
            let dataObj={
                name:this.addName,
                permission:this.addPermission,
                id:this.putId,
            };
            this.baseAPI.axiosData('/api-u/permissions','PUT',dataObj).then(res => {
                if(res.data.success)
                {
                    this.$notification['success']({
                        message: '修改成功',
                    });
                    this.showAdd = false;
                    this.addPermission='';
                    this.addName='';
                }
                else
                {
                    this.$notification['error']({
                        message: res.data.errorMessage,
                    });
                }
            })
        }
        this.fetch({ 
            size: this.tableSize,
            current: 1,
            name:this.powerName,
            permission:this.permission,
        });
    },
    cancelAdd(){
        this.addPermission='';
        this.addName='';
    },
    editPower(obj){
        console.log(obj)
        this.putId=obj.id;
        this.addName=obj.name;
        this.addPermission=obj.permission;
        this.okText='修改';
        this.showAdd=true;
    },
    delPower(obj){
        var that=this;
        this.$confirm({
            title: '警告',
            content: '确定删除该权限吗？',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                that.baseAPI.axiosData('/api-u/permissions/'+obj.id,'DELETE',{}).then(res => {
                    console.log(res)
                    if(res.data.success)
                    {
                        that.$notification['success']({
                            message: '删除成功',
                        });
                    }
                    else
                    {
                        that.$notification['error']({
                            message: res.data.errorMessage,
                        });
                    }
                    that.fetch({ 
                        size: that.tableSize,
                        current: 1,
                        name:that.powerName,
                        permission:that.permission,
                    });
                })
                // return new Promise((resolve, reject) => {
                //     setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                // }).catch(() => console.log('Oops errors!'));
            },
            onCancel() {},
        });
    }
  }
}
</script>

<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
        margin-left: 2rem;
    }
    .search-box p:nth-child(1)
    {
        margin-left: 0;
    }
    .search-box .ant-input-affix-wrapper
    {
        width: 14rem;
    }
    .search-box .search-btn
    {
        margin-left: 2rem;
    }
    .search-box .add-btn
    {
        float: right;
    }
    .input-box
    {
        margin-bottom: 1rem;
    }
    .input-box p
    {
        display: inline-block;
        width: 20%;
        text-align: right;
    }
    .input-box .ant-input-affix-wrapper
    {
        width: 80%;
    }
    .anticon
    {
        font-size: 20px;
        margin-right: 1rem;
        cursor: pointer;
    }
    .anticon:hover
    {
        color: #1890ff;
    }
    a{
      display: inline-block;
      text-decoration: none;
      color: #1F5EFF;
    }
</style>
